exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".report-add-view{width:500px}", "", {"version":3,"sources":["/divvit-app/client/modals/ReportAddModal/client/modals/ReportAddModal/style.styl","/divvit-app/client/modals/ReportAddModal/style.styl"],"names":[],"mappings":"AAAA,iBACE,WAAA,CCCD","file":"style.styl","sourcesContent":[".report-add-view\n  width: 500px\n",".report-add-view {\n  width: 500px;\n}\n/*# sourceMappingURL=client/modals/ReportAddModal/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/modals/ReportAddModal/style.styl
// module id = 521
// module chunks = 0